import React from 'react';
import { Link } from 'react-router-dom';
import PageTitle from '../components/PageTitle';
import AudioVideoCostModal from '../components/Services/AudioVideoCostModal';
import CollectCallCostModal from '../components/Services/CollectCallCostModal';
import WalletCostModal from '../components/Services/WalletCostModal';
import WalletFeaturesModal from '../components/Services/WalletFeaturesModal';

enum ServiceModal {
  InmateWallet,
  AudioVideo,
  PhoneCards,
  CollectCalls,
  WalletFeatures
}

interface IServicesState {
  modalToDisplay?: ServiceModal
}

class Services extends React.Component<{}, IServicesState> {
  constructor(props) {
    super(props);

    this.state = {};

    this.showModal = this.showModal.bind(this);
  }

  showModal(modalName: ServiceModal) {
    this.setState({ modalToDisplay: modalName });
  }

  clearModal() {
    this.setState({ modalToDisplay: null });
  }

  render() {
    return (
      <div>
        <PageTitle title="Communication Options" />

        <div className="hero bg-primary text-light py-5">
            <div className="container">
              <div className="row pt-5">
                <div className="col-lg-8 offset-lg-2 py-5">
                <h1 className="d-none">Communication Options</h1>
                <span className="page-icon rt-communications"></span>
                <h2>With Reliance, you have more flexible options to connect with your friends and family</h2>
              </div>
            </div>

            </div>
          </div>

          <main className="container">
            <div className="row py-5">
              <div className="col-md-6 image-service srvc-inmatewallet d-flex justify-content-center">
                <span className="align-self-center"></span>
              </div>

              <div className="col-md-6 py-5">
                <h3>Inmate Wallet - All Options</h3>
                <h4>(Texting, Calling + Entertainment)</h4>
                <p>The funds paid into an <b>Inmate Wallet - All Options</b> account are tied directly to an inmate’s personal device for them to use for texting, voice and video calls, and games, music and entertainment (where available). At most facilities, you can call the inmate directly. This account allows the inmate to communicate with multiple phone numbers. These funds are non-transferable and non-refundable. Credit card and transaction fees apply. </p>
              <button type="button" className="btn btn-action btn-block mt-3" onClick={() => this.showModal(ServiceModal.InmateWallet)}>See details and costs</button>
              <button type="button" className="btn btn-action btn-block mt-3" onClick={() => this.showModal(ServiceModal.WalletFeatures)}>See Reliance Tablet Phone Features</button> 
            </div>
          </div>

          <WalletCostModal
            show={this.state.modalToDisplay == ServiceModal.InmateWallet}
            onHide={this.clearModal.bind(this)} />

          <WalletFeaturesModal
            show={this.state.modalToDisplay == ServiceModal.WalletFeatures}
            onHide={this.clearModal.bind(this)} />

{/* TODO: Update CSS classes and images */}
          <div className="row py-5 flex-row-reverse">
            <div className="col-md-6 image-service srvc-phonecard d-flex justify-content-center">
              <span className="align-self-center"></span>
            </div>

            <div className="col-md-6 py-5">
              <h3>Inmate Wallet - Voice & Video Calls Only</h3>         
              <p>Funds paid into an <b>Inmate Wallet - Voice & Video Calls Only</b> account are tied directly to an inmate’s personal device for them to use for voice and video calling <b>ONLY</b>. At most facilities, you can call the inmate directly. This account allows the inmate to call multiple phone numbers. No fees apply to the purchase, and it is refundable.</p>
              <button type="button" className="btn btn-action btn-block mt-3" onClick={() => this.showModal(ServiceModal.AudioVideo)}>See details and costs</button>
            </div>
          </div>
          <AudioVideoCostModal
            show={this.state.modalToDisplay == ServiceModal.AudioVideo}
            onHide={this.clearModal.bind(this)} />

          <div className="row py-5">
            <div className="col-md-6 image-service srvc-collectcall d-flex justify-content-center">
              <span className="align-self-center"></span>
            </div>
            <div className="col-md-6 py-5">
              <h3>Prepaid Collect Calls</h3>
              <p>Prepaying for collect calls allows friends and family to receive calls from inmates by funding specific telephone numbers. These calls can be received on a cell phone or landline. Funds in this account can only be used for calls to or from the specified telephone number. At most facilities, you can call the inmate directly. No fees apply to the purchase, and it is refundable.</p>

              <button type="button" className="btn btn-action btn-block mt-3" onClick={() => this.showModal(ServiceModal.CollectCalls)}>See details and costs</button>
            </div>
          </div>
          <CollectCallCostModal
            show={this.state.modalToDisplay == ServiceModal.CollectCalls}
            onHide={this.clearModal.bind(this)} />
        </main>

        <div className="bg-dark text-light p-5">
          <div className="container">
            <div className="row py-5">
              <div className="col-lg-10 offset-lg-2">
                <span className="section-icon rt-helpline"></span>
                <h3>Inmate Help Line & Text Support</h3>
                <p>The inmate help line allows inmates to contact our support directly with any communication problems they may have. Additionally, inmates can text our support staff through their personal texting device for assistance when needed.</p>
              </div>
            </div>
          </div>
        </div>

        <div className="container">
          <div className="bg-light rounded text-center p-5 my-5">
            <h5>Services vary by location. To learn what’s available at your facility…</h5>
            <Link to="/checkout/facility" className="btn btn-block btn-action mt-3">Get Started</Link>
          </div>
        </div>
      </div>
    );
  }
}

export default Services;
